import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MatDialog } from '@angular/material';

import { AccessDeniedDialogComponent } from 'src/components/access-denied-dialog/access-denied-dialog.component';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private dialog: MatDialog,
    private globalCfgService: GlobalCfgService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let url: string = state.url;
    // console.log('canActivate: ', state);

    return this.checkAcl(url).pipe(map(res => res));
  }

  checkAcl(url: string): Observable<boolean> {

    var arr = url.split('/');
    var view  = arr[arr.length - 1];
    // console.log('view: ', view);

    // var hasAccess = this.globalCfgService.getAclValueFor(view);
    return this.globalCfgService.checkGcpAcl(view).pipe(
      map(res => {

        // console.log(res);
        var hasAccess = res;
        if (hasAccess == false) {
          this.dialog.open(AccessDeniedDialogComponent, {
            width: "450px"
          });
        }

        if (hasAccess == undefined) {
          this.router.navigate(['']);
        }

        return hasAccess;
      })
    );
  }
}